import { atom } from 'recoil';
import { ATOM_KEYS } from 'utils/const/recoilKeys';
// Types
import { Winner } from 'types/lottery/winner';

export const fourthWinnersState = atom<Winner[]>({
  key: ATOM_KEYS.FOURTH_WINNERS_STATE,
  default: [],
});
